import { Api } from 'lib';
import { store } from 'store';

/*
  storeId: 'home', 'shoutout'
*/

async function updateGames(storeId) {
  const state = store.getState();
  if (!['home', 'shoutout', 'admin'].includes(storeId) || !state || !state[storeId]) {
    return;
  }

  const games = state[storeId]?.games;
  if (!games?.length) return;

  const gameIds = games.map((x) => x._id);
  const res = await Api.post('/games/get', { gameIds });
  if (!res) return;

  store.dispatch({
    type: 'UPDATE_GAMES',
    payload: res
  });
}

export default updateGames;
